module.exports = __webpack_public_path__ + "media/images/subject_img/ECONOMICS-a58d0959df43c264a20242836ded99c6.jpg";